import { useSnapshot } from "valtio";
import { chargesBookingValidationStore } from "../mybooksv3/booking-commonstate";
import {
  AgmodalStore,
  cargoStore,
  configStore,
  containerStore,
  contractsStore,
  EntityV2Store,
  fclChargesStore,
  quoteDataRec,
} from "../state/CommonState";
import FCLChargesCompv3 from "../quotesv3/fcl-charges-v3.js";
import {
  FCLChargesView,
  fclTotalsKey,
  getContainerList,
  getFCLChargesTotal,
  hasMissingFCLDetails,
  isFCLShipment,
  splitFCLCharges,
  useFCLAutoTotals,
} from "./fcl-rate-request-charges.js";
import { useEffect, useMemo, useState } from "react";
import { loadAiHistory, getAiHistory } from "../components/AiChargeParse";
import Utils from "../util/Utils";
import { TableLabel } from "../v3-componets/AgTableLabel";
import chargedetails from "../assets/images/chargedetails.svg";
import { Card } from "../v3-componets/AgCard";
import { Headspan } from "../v3-componets/AgHeadspan";
import { chargesData1 } from "../StaticData";
import QuoteCalcV2 from "../util/quote-calc-v2";
import { loader } from "../util/loader.js";
import Api from "../state/Api.js";
import { CHARGETYPES, PERMISSIONS_NEW } from "../util/constants.js";
import RoleUtils from "../util/RoleUtils.js";
import TenantUtils from "../util/tenant.utils.js";
import {
  Controller,
  FormProvider,
  useFieldArray,
  useForm,
  useFormContext,
  useWatch,
} from "react-hook-form";
import { PRICING_CATEGORY } from "../charges_data/LCLCharges.js";
import { TableComboInput } from "../components/AgComponents.js";
import { editapprovalStore } from "../quote-approval/editapprovalStore.js";
import {
  LCLChargesCompFrom,
  LCLChargesCompFromNew,
} from "../quick-quotev3/editchargenew.js";
import { QuotationValidationStore } from "../state/validation-stores.js";
import { calcCargoDetails } from "../CargoComp.js";
const POST_RATEREQUEST_URI = `${process.env.REACT_APP_API_SERVER}/api/v1/raterequest`;

export default function QuoteEditCharge(props) {
  const { trigger, clickSave, clickContract, setdata, setClickSave, setClickContact, reviseCharges, setReviseCharges, setOpenCopyMail } = props;
  useSnapshot(contractsStore);
  useSnapshot(editapprovalStore);
  // FCL charges are edited in fclChargesStore (per-container table); LCL in the form's "list"
  const fclSnap = useSnapshot(fclChargesStore);
  const containerSnap = useSnapshot(containerStore);
  const isFCL = isFCLShipment(editapprovalStore.quote?.quoteData?.shipmentType);
  const fclListKey = fclTotalsKey(fclSnap.list, containerStore.list);
  useFCLAutoTotals(isFCL, () => quoteDataRec.emptycontainerweight);
  const chargesTotal = (list) =>
    isFCL ? getFCLChargesTotal(list, containerStore.list) : Utils.getTotal(list);
  // AI charge history of this rate request: loaded per request #, saved with it (save below)
  const aiHistoryKey = editapprovalStore.quote?._id || editapprovalStore.quote?.quoteData?.quotationNum || "";
  useEffect(() => { loadAiHistory("rateRequest", aiHistoryKey, editapprovalStore.quote?.quoteData?.aiChargeHistory) }, [aiHistoryKey]);
  //editapprovalStore.quote!=undefined && editapprovalStore.quote?.quoteData!=undefined &&
  const [originallist, setOriginallist] = useState([]);
  const [originalrebatelist, setOriginalrebatelist] = useState([]);
  const [originalpkblist, setOriginalpkblist] = useState([]);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [conditions, setConditions] = useState([]);
  const charges = useForm({
    defaultValues: {
      groupedByCategory: {},
      rebate: [],
      pkb: [],
      list: [],
      originallistlist: [],
      originallistrebate: [],
      originallistpkb: [],
      initialLength: 0,
      initialLength1:1,
    },
  });
  const { control, setValue } = charges;

  const watchedList = useWatch({
    control,
    name: "list",
  });

  const watchedRebate = useWatch({
    control,
    name: "rebate",
  });

  const watchedPkb = useWatch({
    control,
    name: "pkb",
  });

  const req = useMemo(() => {
    let limits = [];
    let err = [];
    let lobj = {};
    let eobj = {};
    let showapprove = false;
    if (
      watchedList != undefined &&
      watchedPkb != undefined &&
      watchedRebate != undefined
    ) {
      let l = JSON.parse(JSON.stringify(editapprovalStore.quote?.quoteData));
      l["orginalchargesList"] = [];
      l["chargesList"] = [];
      l["shipperchargesList"] = [];
      l["consigneechargesList"] = [];
      l["pkb"] = [];
      l["rebate"] = [];
      const revisedList = isFCL ? fclChargesStore.list : watchedList;
      if (revisedList.length > 0) {
        l["orginalchargesList"] = JSON.parse(JSON.stringify(revisedList));
      }
      if (
        watchedPkb.length > 0 &&
        watchedPkb[0]["total"] != undefined &&
        watchedPkb[0]["total"] != 0
      ) {
        l["pkb"] = JSON.parse(JSON.stringify(watchedPkb));
        l["pkb"][0]["isIncluded"] = "Yes";
      }
      if (
        watchedRebate.length > 0 &&
        watchedRebate[0]["total"] != undefined &&
        watchedRebate[0]["total"] != 0
      ) {
        l["rebate"] = JSON.parse(JSON.stringify(watchedRebate));
        l["rebate"][0]["isIncluded"] = "Yes";
      }
      let z = l["orginalchargesList"];
      if (isFCL) {
        Object.assign(l, splitFCLCharges(z, containerStore.list));
        l["containerList"] = JSON.parse(JSON.stringify(containerStore.list));
        // a rate request has one revised list; quick-quote carrier options would make QuoteCalcV2 read those instead
        delete l["multicharge"];
      } else {
      for (let i = 0; i < z.length; i++) {
        if (z[i]["total"] != 0) {
          z[i]["isIncluded"] = "Yes";
          if (z[i]["onaccount"] == "On Your Account") {
            l["chargesList"].push(z[i]);
          }
          if (z[i]["onaccount"] == "Shipper's Account") {
            l["shipperchargesList"].push(z[i]);
          }
          if (z[i]["onaccount"] == "Consignee's Account") {
            l["consigneechargesList"].push(z[i]);
          }
        }
      }
      }
      l["orginalchargesList"] = z;
      let k = new QuoteCalcV2(l).recalc();
      l["quoteValue"] = k.quoteValue;
      l["quoteValueUSD"] = k.quoteValueUSD;
      l["nomrg_chargesList"] = originallist;
      l["nomrg_rebate"] = originalrebatelist;
      l["nomrg_pkb"] = originalpkblist;
      if (k.quoteValue != 0) {
        let t1 =
          chargesTotal(originallist) +
          Utils.getTotal(originalrebatelist) +
          Utils.getTotal(originalpkblist);
        let t2 = chargesTotal(l["orginalchargesList"]);
        let t3 = Utils.getTotal(l["pkb"]);
        let t4 = Utils.getTotal(l["rebate"]);
        t2 = t2 + t4 + t3;
        conditions.map((e) => {
          if (e.reductionPercentage != undefined) {
            console.log(
              "++++++++++++++++++++9000",
              (t2 / t1) * 100,
              100 - e.reductionPercentage,
            );
            if ((t2 / t1) * 100 < 100 - e.reductionPercentage) {
              if (lobj[JSON.stringify(e)] == undefined) {
                lobj[JSON.stringify(e)] = 1;
                limits.push(e);
              }
              let e2 = `Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${(100 - e.reductionPercentage).toFixed(2)}%).`;
              if (eobj[JSON.stringify(e2)] == undefined) {
                eobj[JSON.stringify(e2)] = 1;
                err.push(e2);
              }
            }
          }
          if (e.reductionValue != undefined) {
            let v = configStore.getExchangeRate(e.reductionValueCurrency);
            let t5 = t1 / v;
            let t6 = t2 / v;
            let t7 = t5 - e.reductionValue;
            if (t7 > t6) {
              let e2 = `Charge list total: ${Utils.N(t5, e.reductionValueCurrency)} (100.00%), Revised list total: ${Utils.N(t6, e.reductionValueCurrency)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${Utils.N(t7, e.reductionValueCurrency)}%).`;
              if (lobj[JSON.stringify(e)] == undefined) {
                lobj[JSON.stringify(e)] = 1;
                limits.push(e);
              }
              if (eobj[JSON.stringify(e2)] == undefined) {
                eobj[JSON.stringify(e2)] = 1;
                err.push(e2);
              }
            }
            // l['orginalchargesList'].map(e1=>{
            //     if(e1['currency']==e.reductionValueCurrency){
            //         if(e1['total']<e.reductionValue){
            //             if(lobj[JSON.stringify(e)]==undefined){
            //               lobj[JSON.stringify(e)] = 1
            //               limits.push(e)
            //             }
            //             let e2 = `${e1['chargeDescription']}, Currency: ${e.reductionValueCurrency}, Totol: ${e1['total']} is less than the allowed limit ${e.reductionValue}`
            //             if(eobj[JSON.stringify(e2)]==undefined){
            //               eobj[JSON.stringify(e2)] = 1
            //               err.push(e2)
            //             }
            //         }
            //     }
            // })
          }
        });
        if (err.length == 0 && t1 != t2 && conditions.length == 0) {
          err.push(
            `Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%).`,
          );
        }
        if (err.length > 0) {
          showapprove = true;
        } else {
          showapprove = false;
        }
      }
    }

    return { limits, err, showapprove };
  }, [
    watchedList,
    watchedPkb,
    watchedRebate,
    conditions,
    originallist,
    cargoStore.cargoList,
    isFCL,
    fclListKey,
    JSON.stringify(containerSnap.list),
  ]);

  useEffect(() => {
    if (
      JSON.stringify(contractsStore.current) !=
        JSON.stringify(editapprovalStore.quote?.quoteData) &&
      editapprovalStore.quote?.quoteData != undefined
    ) {
      contractsStore.current = JSON.parse(
        JSON.stringify(editapprovalStore.quote?.quoteData),
      );
    }
  }, [JSON.stringify(editapprovalStore.quote?.quoteData)]);

  useEffect(() => {
    if (editapprovalStore.quote?.conditionsPayload) {
      const callback = (data) => {
        setConditions(data.data);
        setShow1(true);
        loader.hide();
      };
      loader.show();
      Api.apiGetconditionslist(
        editapprovalStore.quote.conditionsPayload,
        callback,
      );
    }
  }, []);

  useEffect(()=>{
    if(clickSave){
      save('save')
    }
  },[clickSave])

  useEffect(()=>{
    if(clickContract){
      save('contract')
    }
  },[clickContract])

  const save = async (stage) => {
    const isValid = await trigger();

    if (isValid) {
      await setdata()
      if (quoteDataRec.salesperson === "") {
        setClickSave(false)
    setClickContact(false)
          return configStore.setModalMessage(`Please select the sales person`);
        }
        if (quoteDataRec.customerService === "") {
          setClickSave(false)
    setClickContact(false)
          return configStore.setModalMessage(
            `Please select the customer service`,
          );
        }
      if (QuotationValidationStore.isValid2()) {
        loader.show();
        let limits = [];
        let lobj = {};
        let eobj = {};
        let err = [];
        if (
          editapprovalStore.quote?.quoteData != undefined &&
          watchedList != undefined &&
          watchedPkb != undefined &&
          watchedRebate != undefined
        ) {
          let l = JSON.parse(JSON.stringify(editapprovalStore.quote));
          console.log("++++++++++++++++++++++++9000000",cargoStore.cargoList)
          cargoStore.cargoList = cargoStore.cargoList.map((cargo) =>
            calcCargoDetails(
              cargo,
              undefined,
              quoteDataRec.volumeInDimensions ?? true,
            ),
          );
          cargoStore.calculateCargoTotals();
          l["cargoList"] = JSON.parse(JSON.stringify(cargoStore.cargoList));
          l["cargoTotals"] = cargoStore.cargoTotals;
          chargesBookingValidationStore.isNew = false;
          let kz = true;
          if (isFCL) {
            fclChargesStore.calculateChargesTotalsindex("list", quoteDataRec.emptycontainerweight);
            kz = !hasMissingFCLDetails(fclChargesStore.list, containerStore.list);
          } else if (
            watchedList &&
            !watchedList.every((charge, index) =>
              Object.keys(charge).every((chargeKey) =>
                chargesBookingValidationStore.isValidChargelclform(
                  chargeKey,
                  index,
                  watchedList,
                ),
              ),
            )
          ) {
            kz = false;
          }
          if (!kz) {
            setClickSave(false)
    setClickContact(false)
            loader.hide()
            configStore.setModalMessage(
              `Please check the charges detail fields`,
            );
            return false;
          }
          l["orginalchargesList"] = [];
          l["chargesList"] = [];
          l["shipperchargesList"] = [];
          l["consigneechargesList"] = [];
          l["pkb"] = [];
          l["rebate"] = [];
          const revisedList = isFCL ? fclChargesStore.list : watchedList;
          if (revisedList.length > 0) {
            l["orginalchargesList"] = JSON.parse(JSON.stringify(revisedList));
          }
          if (
            watchedPkb.length > 0 &&
            watchedPkb[0]["total"] != undefined &&
            watchedPkb[0]["total"] != 0
          ) {
            l["pkb"] = JSON.parse(JSON.stringify(watchedPkb));
            l["pkb"][0]["id"] = 1;
            l["pkb"][0]["isIncluded"] = "Yes";
          }
          if (
            watchedRebate.length > 0 &&
            watchedRebate[0]["total"] != undefined &&
            watchedRebate[0]["total"] != 0
          ) {
            l["rebate"] = JSON.parse(JSON.stringify(watchedRebate));
            l["rebate"][0]["id"] = 1;
            l["rebate"][0]["isIncluded"] = "Yes";
          }
          let z = l["orginalchargesList"];
          if (isFCL) {
            Object.assign(l, splitFCLCharges(z, containerStore.list));
            l["containerList"] = JSON.parse(JSON.stringify(containerStore.list));
            delete l["multicharge"];
          } else {
          for (let i = 0; i < z.length; i++) {
            z[i]["id"] = i + 1;
            if (z[i]["total"] != 0) {
              z[i]["isIncluded"] = "Yes";
              if (z[i]["onaccount"] == "On Your Account") {
                l["chargesList"].push(z[i]);
              }
              if (z[i]["onaccount"] == "Shipper's Account") {
                l["shipperchargesList"].push(z[i]);
              }
              if (z[i]["onaccount"] == "Consignee's Account") {
                l["consigneechargesList"].push(z[i]);
              }
            }
          }
          }
          l["orginalchargesList"] = z;
          let k = new QuoteCalcV2(l).recalc();
          l["quoteValue"] = k.quoteValue;
          l["quoteValueUSD"] = k.quoteValueUSD;
          l["nomrg_chargesList"] = originallist;
          l["nomrg_rebate"] = originalrebatelist;
          l["nomrg_pkb"] = originalpkblist;
          editapprovalStore.quote.quoteData = JSON.parse(JSON.stringify(l));
          if (k.quoteValue != 0) {
            let t1 =
              chargesTotal(originallist) +
              Utils.getTotal(originalrebatelist) +
              Utils.getTotal(originalpkblist);
            let t2 = chargesTotal(l["orginalchargesList"]);
            let t3 = Utils.getTotal(l["pkb"]);
            let t4 = Utils.getTotal(l["rebate"]);
            t2 = t2 + t4 + t3;
            conditions.map((e) => {
              if (e.reductionPercentage != undefined) {
                if ((t2 / t1) * 100 < 100 - e.reductionPercentage) {
                  if (lobj[JSON.stringify(e)] == undefined) {
                    lobj[JSON.stringify(e)] = 1;
                    limits.push(e);
                  }
                  let e2 = `Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${(100 - e.reductionPercentage).toFixed(2)}%).`;
                  if (eobj[JSON.stringify(e2)] == undefined) {
                    eobj[JSON.stringify(e2)] = 1;
                    err.push(e2);
                  }
                }
              }
              if (e.reductionValue != undefined) {
                let v = configStore.getExchangeRate(e.reductionValueCurrency);
                let t5 = t1 / v;
                let t6 = t2 / v;
                let t7 = t5 - e.reductionValue;
                if (t7 > t6) {
                  let e2 = `Charge list total: ${Utils.N(t5, e.reductionValueCurrency)} (100.00%), Revised list total: ${Utils.N(t6, e.reductionValueCurrency)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${Utils.N(t7, e.reductionValueCurrency)}%).`;
                  if (lobj[JSON.stringify(e)] == undefined) {
                    lobj[JSON.stringify(e)] = 1;
                    limits.push(e);
                  }
                  if (eobj[JSON.stringify(e2)] == undefined) {
                    eobj[JSON.stringify(e2)] = 1;
                    err.push(e2);
                  }
                }
                // l['orginalchargesList'].map(e1=>{
                //     if(e1['currency']==e.reductionValueCurrency){
                //         if(e1['total']<e.reductionValue){
                //             if(lobj[JSON.stringify(e)]==undefined){
                //               lobj[JSON.stringify(e)] = 1
                //               limits.push(e)
                //             }
                //             let e2 = `${e1['chargeDescription']}, Currency: ${e.reductionValueCurrency}, Totol: ${e1['total']} is less than the allowed limit ${e.reductionValue}`
                //             if(eobj[JSON.stringify(e2)]==undefined){
                //               eobj[JSON.stringify(e2)] = 1
                //               err.push(e2)
                //             }
                //         }
                //     }
                // })
              }
            });
            if (err.length == 0 && t1 != t2 && conditions.length == 0) {
              err.push(
                `Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%).`,
              );
            }
            if (err.length > 0) {
              l["limitdetails"] = limits;
            }
            if (stage == "approve") {
              editapprovalStore.quote["totalcharge"] = t1;
              editapprovalStore.quote["totalrevisedcharge"] = t2;
              editapprovalStore.quote["limitdetails"] = limits;
              editapprovalStore.quote["limiterrors"] = err;
              editapprovalStore.quote["mrg_chargesList"] =
                l["orginalchargesList"];
              editapprovalStore.quote["nomrg_chargesList"] =
                l["nomrg_chargesList"];
              editapprovalStore.quote["nomrg_rebate"] = l["nomrg_rebate"];
              editapprovalStore.quote["pkb"] = l["pkb"];
              editapprovalStore.quote["rebate"] = l["rebate"];
              editapprovalStore.quote["cargoList"] = l["cargoList"]
              editapprovalStore.quote["cargoTotals"] = l["cargoTotals"]
              if (isFCL) editapprovalStore.quote["containerList"] = l["containerList"]
            } else {
              editapprovalStore.quote["cargoList"] = l["cargoList"]
              editapprovalStore.quote["cargoTotals"] = l["cargoTotals"]
              if (isFCL) editapprovalStore.quote["containerList"] = l["containerList"]
              editapprovalStore.quote["chargesList"] = l["orginalchargesList"];
              editapprovalStore.quote["pkb"] = l["pkb"];
              editapprovalStore.quote["rebate"] = l["rebate"];
              editapprovalStore.quote.quoteData = JSON.parse(JSON.stringify(l));
            }
            let a = [];

            const e = quoteDataRec;
            e.portOfReceipt =
              e.portOfReceipt !== "" ? e.portOfReceipt : e.portOfLoading;
            e.portOfDischarge =
              e.portOfDischarge !== ""
                ? e.portOfDischarge
                : e.finalPlaceOfDelivery;
            let quoteSummary = {};
            quoteSummary = {
              sender: e.sender,
              shipmentType: e.shipmentType,
              shipmentScope: e.shipmentScope,
              origin: e.origin,
              destination: e.destination,
              customerEmail: e.customerEmail,
              gst: e.gst,
              entityId: e.entityId,
            };
            if (e.multidest != undefined && e.multidest.length > 1) {
              for (let i = 0; i < e.multidest.length; i++) {
                if (i == 0) {
                  quoteSummary.destination = e.multidest[i]["destination"];
                } else {
                  let k = i + 1;
                  quoteSummary["destination" + k] =
                    e.multidest[i]["destination"];
                }
              }
            } else {
              quoteSummary.destination = e.destination;
            }

            // FCL: the carrier picked (by SCAC) lives in multicharge[0]; the contract and booking read quoteData.carrier.
            // Same as quote-v3's save (Api.setsaveQuote), so Move to Contract / Save carry the selected carrier.
            if (
              isFCL &&
              quoteDataRec.multicharge != undefined &&
              quoteDataRec.multicharge.length == 1 &&
              quoteDataRec.multicharge[0].carrier
            ) {
              quoteDataRec.carrier = quoteDataRec.multicharge[0].carrier;
            }
            editapprovalStore.quote.quoteData = JSON.parse(
              JSON.stringify(quoteDataRec),
            );
            editapprovalStore.quote.quoteSummary = JSON.parse(
              JSON.stringify(quoteSummary),
            );
            console.log(editapprovalStore.quote, "quoteDocumentquoteDocument");
            editapprovalStore.quote.quoteData.createType="RateRequest"
            editapprovalStore.quote.quoteData.aiChargeHistory = getAiHistory("rateRequest")
            if (stage == "approve") {
              editapprovalStore.quote.status = "PENDING"
            }
            if(stage!="contract"){
              Api.post(POST_RATEREQUEST_URI, editapprovalStore.quote)
              setReviseCharges(false)
              setShow(false)
              if (stage == "approve") {
                configStore.setModalMessage(`Request Raised Successfully`);
              }else{
                configStore.setModalMessage(`Successfully Saved`);
              }
            }else{
              loader.show()
              const callback = (d)=>{
                configStore.setModalMessage(`${quoteDataRec.quotationNum} has been successfully moved to the contract.`)
                AgmodalStore.pageVisible = false;
                AgmodalStore.apiCall = true;
                loader.hide()
              }
              Api.RequestMovetoContact(editapprovalStore.quote,callback)
            }
            AgmodalStore.pageVisible = false;
            AgmodalStore.apiCall = true;
          } else {
            configStore.setModalMessage(`On your account is empty.`);
          }
        }
        loader.hide();
      } else {
        loader.hide()
        configStore.setModalMessage(QuotationValidationStore.message);
      }
    } else {
      loader.hide()
      configStore.setModalMessage(`Please check the fields`);
    }
    setClickSave(false)
    setClickContact(false)
  };
  useEffect(() => {
    if (show) {
      setShow(false);
    }
  }, [JSON.stringify(cargoStore.cargoList)]);

  useEffect(() => {
    if (
      !show &&
      JSON.stringify(editapprovalStore.quote?.quoteData) ==
        JSON.stringify(contractsStore.current)
    ) {
      chargesBookingValidationStore.isNew = true;
      cargoStore.calculateCargoTotals();
      let c = [];
      let k = [];
      if (editapprovalStore.quote.chargesList != undefined) {
        c = editapprovalStore.quote.chargesList;
      }
      if(editapprovalStore.quote.mrg_chargesList!=undefined){
          k = editapprovalStore.quote.mrg_chargesList
      }

      let type = editapprovalStore.quote?.quoteData.shipmentType;
      let scope = editapprovalStore.quote?.quoteData.shipmentScope;
      // scope-specific defaults exist only for LCL; FCL/Air have no rebate/pkb defaults
      const data1 = chargesData1[type.toLowerCase() + scope.toLowerCase()] || { rebate: [], pkb: [] };
      if (
        editapprovalStore.quote?.rebate == undefined ||
        editapprovalStore.quote?.rebate.length == 0 ||
        Object.keys(editapprovalStore.quote?.rebate).length == 0
      ) {
        setValue("rebate", JSON.parse(JSON.stringify(data1.rebate)));
      } else {
        let rebate = editapprovalStore.quote?.rebate;
        if (Utils.isObject(editapprovalStore.quote?.rebate)) {
          rebate = [editapprovalStore.quote?.rebate];
        }
        rebate[0]["category"] = "REBATE";
        if (rebate[0]["chargeDescription"] == "Rebate") {
          if (editapprovalStore.quote?.nomrg_rebate != undefined) {
            if (
              JSON.stringify(originalrebatelist) !=
              JSON.stringify(editapprovalStore.quote?.nomrg_rebate)
            ) {
              setValue(
                "originallistrebate",
                JSON.parse(
                  JSON.stringify(editapprovalStore.quote?.nomrg_rebate),
                ),
              );
              setOriginalrebatelist(
                JSON.parse(
                  JSON.stringify(editapprovalStore.quote?.nomrg_rebate),
                ),
              );
            }
          } else {
            setValue("originallistrebate", JSON.parse(JSON.stringify(rebate)));
            setOriginalrebatelist(JSON.parse(JSON.stringify(rebate)));
          }
          setValue("rebate", JSON.parse(JSON.stringify(rebate)));
        } else {
          setValue("rebate", JSON.parse(JSON.stringify(data1.rebate)));
        }
      }
      if (
        editapprovalStore.quote?.pkb == undefined ||
        editapprovalStore.quote?.pkb.length == 0
      ) {
        setValue("pkb", JSON.parse(JSON.stringify(data1.pkb)));
      } else {
        let pkb = editapprovalStore.quote?.pkb;
        if (Utils.isObject(editapprovalStore.quote?.pkb)) {
          pkb = [editapprovalStore.quote?.pkb];
          pkb[0]["category"] = "PKB";
        }
        if (pkb[0]["chargeDescription"] == "Freight Commission") {
          if (editapprovalStore.quote?.nomrg_pkb != undefined) {
            if (
              JSON.stringify(originalpkblist) !=
              JSON.stringify(editapprovalStore.quote?.nomrg_pkb)
            ) {
              setValue(
                "originallistpkb",
                JSON.parse(JSON.stringify(editapprovalStore.quote?.nomrg_pkb)),
              );
              setOriginalpkblist(
                JSON.parse(JSON.stringify(editapprovalStore.quote?.nomrg_pkb)),
              );
            }
          } else {
            setValue("originallistpkb", JSON.parse(JSON.stringify(pkb)));
            setOriginalpkblist(JSON.parse(JSON.stringify(pkb)));
          }
          setValue("pkb", JSON.parse(JSON.stringify(pkb)));
        } else {
          setValue("pkb", JSON.parse(JSON.stringify(data1.pkb)));
        }
      }
      if (editapprovalStore.quote?.nomrg_chargesList != undefined) {
        c = editapprovalStore.quote?.nomrg_chargesList;
      }
      if (k != undefined && k.length == 0) {
        k = c;
      }
      if (JSON.stringify(c) != JSON.stringify(originallist)) {
        setValue("originallistlist", c);
        setOriginallist(c);
      }

      if (k.length > 0) {
        setValue("initialLength", k.length);
        k = JSON.parse(JSON.stringify(k));
        setValue("list", k);
      }
      if (isFCL) {
        if (containerStore.list.length == 0) {
          containerStore.list = JSON.parse(JSON.stringify(getContainerList(editapprovalStore.quote)));
        }
        fclChargesStore.list = JSON.parse(JSON.stringify(k));
        fclChargesStore.initialLength = k.length;
      }
      setShow(true);
    }
    if(!reviseCharges && editapprovalStore.quote?.status=='REJECTED'){
      setReviseCharges(true)
    }
  }, [
    JSON.stringify(editapprovalStore.quote?.quoteData),
    JSON.stringify(contractsStore.current),
    show,
  ]);

  const getlcv = (ob, key) => {
    if (ob != undefined) {
      if (ob[key] != undefined) {
        return ob[key];
      }
    }
    return "-";
  };

  return (
    <>
      {show && (
        <>
          {show1 && (
            <>
              <FormProvider {...charges}>
                <div class="columns is-multiline">
                  {!reviseCharges ? (
                    <>
                    <div class="column is-12">
<hr />
                    </div>
                      {['PENDING','ACCEPTED'].indexOf(editapprovalStore.quote?.status)==-1 && <><div class="column is-10"></div>
                      <div class="column is-2">
                        <div className="control" style={{textAlign:"right"}}>
                          <button
                            className="button"
                            style={{
                              backgroundColor:
                                process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                              color: "#fff",
                            }}
                            onClick={() => {
                              setShow(false)
                              setReviseCharges(true);
                            }}
                          >
                            Revise Charges
                          </button>
                        </div>
                      </div></>}
                      {isFCL ? <div class="column is-12">
                        <FCLChargesView list={fclSnap.list} containerList={containerSnap.list} heading="Charge Details" />
                      </div> :
                      <div class="column is-12">
                        <LCLChargesCompFromNew hidehr={true}
                          form={charges}
                          listkey={"list"}
                          oyahide={true}
                          contract={editapprovalStore.quote?.quoteData}
                          isDisable={true}
                          heading={"Charge Details"}
                        />
                        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST.REBATE) && <LCLChargesCompFromNew
                          form={charges}
                          listkey={"rebate"}
                          hide={true}
                          isDisable={true}
                          contract={editapprovalStore.quote?.quoteData}
                        />}
                        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST.PKB) && <LCLChargesCompFromNew
                          IL={"initialLength1"}
                          form={charges}
                          listkey={"pkb"}
                          hide={true}
                          isDisable={true}
                          contract={editapprovalStore.quote?.quoteData}
                        />}
                      </div>}
                      {['PENDING','REJECTED'].indexOf(editapprovalStore.quote?.status)==-1 && <><div class="column is-10"></div>
                      <div class="column is-2">
                        <div className="control" style={{textAlign:"right"}}>
                          <button
                            className="button"
                            style={{
                              backgroundColor:
                                process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                              color: "#fff",
                            }}
                            onClick={() => {
                              setOpenCopyMail(true);
                            }}
                          >
                            Copy Mail
                          </button>
                        </div>
                      </div></>}
                    </>
                  ) : isFCL ? (
                    <>
                      <div class="column is-12">
                        <FCLChargesView list={originallist} containerList={containerSnap.list} heading="Charge Details" />
                      </div>
                      <div class="column is-12">
                        <FCLChargesCompv3 heading="Revised Details" />
                      </div>
                    </>
                  ) : (
                    <>
                      <div class="column is-4">
                        <LCLChargesCompFrom
                          form={charges}
                          listkey={"originallistlist"}
                          oyahide={true}
                          contract={editapprovalStore.quote?.quoteData}
                          isDisable={true}
                          heading={"Charge Details"}
                        />
                        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST.REBATE) && <LCLChargesCompFrom
                          form={charges}
                          listkey={"originallistrebate"}
                          hide={true}
                          isDisable={true}
                          contract={editapprovalStore.quote?.quoteData}
                        />}
                        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST.PKB) && <LCLChargesCompFrom
                          IL={"initialLength1"}
                          form={charges}
                          listkey={"originallistpkb"}
                          hide={true}
                          isDisable={true}
                          contract={editapprovalStore.quote?.quoteData}
                        />}
                      </div>
                      <div class="column is-8">
                        <LCLChargesCompFrom
                          form={charges}
                          listkey={"list"}
                          contract={editapprovalStore.quote?.quoteData}
                          heading={"Revised Details"}
                          aiHistory={{ scope: "rateRequest" }}
                        />
                        <hr />
                        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST.REBATE) && <LCLChargesCompFrom
                          form={charges}
                          listkey={"rebate"}
                          hide={true}
                          contract={editapprovalStore.quote?.quoteData}
                        />}
                        <hr />
                        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST.PKB) && <LCLChargesCompFrom
                          IL={"initialLength1"}
                          form={charges}
                          listkey={"pkb"}
                          hide={true}
                          contract={editapprovalStore.quote?.quoteData}
                        />}
                      </div>{" "}
                    </>
                  )}
                </div>
              </FormProvider>
              {(req.limits.length > 0 || req.err.length > 0) && (
                <>
                  {" "}
                  <Card>
                    <Headspan
                      color="#00000"
                      fontSize="14px"
                      fontWeight="900"
                      data="Charge Limit"
                    />
                    {req.limits.length > 0 && (
                      <div className="table-container">
                        <table style={{ border: "none", width: "100%" }}>
                          <thead>
                            <tr
                              style={{
                                fontWeight: "900",
                                border: "solid 0.5px #D4D4D4",
                              }}
                            >
                              <th
                                style={{
                                  color:
                                    process.env.REACT_APP_ENTERPRISE_COLOUR,
                                  padding: "10px",
                                }}
                              >
                                Origin Country
                              </th>
                              <th
                                style={{
                                  color:
                                    process.env.REACT_APP_ENTERPRISE_COLOUR,
                                  padding: "10px",
                                }}
                              >
                                Destination Country
                              </th>
                              <th
                                style={{
                                  color:
                                    process.env.REACT_APP_ENTERPRISE_COLOUR,
                                  padding: "10px",
                                }}
                              >
                                POL
                              </th>
                              <th
                                style={{
                                  color:
                                    process.env.REACT_APP_ENTERPRISE_COLOUR,
                                  padding: "10px",
                                }}
                              >
                                POD
                              </th>
                              <th
                                style={{
                                  color:
                                    process.env.REACT_APP_ENTERPRISE_COLOUR,
                                  padding: "10px",
                                }}
                              >
                                Rate Type
                              </th>
                              <th
                                style={{
                                  color:
                                    process.env.REACT_APP_ENTERPRISE_COLOUR,
                                  padding: "10px",
                                }}
                              >
                                Reduction Percentage
                              </th>
                              <th
                                style={{
                                  color:
                                    process.env.REACT_APP_ENTERPRISE_COLOUR,
                                  padding: "10px",
                                }}
                              >
                                Reduction Value
                              </th>
                              <th
                                style={{
                                  color:
                                    process.env.REACT_APP_ENTERPRISE_COLOUR,
                                  padding: "10px",
                                }}
                              >
                                Reduction Value Currency
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {req.limits.map((e) => {
                              return (
                                <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                  <td
                                    style={{
                                      color: "#555555",
                                      padding: "10px",
                                    }}
                                  >
                                    {getlcv(e, "originCountry")}
                                  </td>
                                  <td
                                    style={{
                                      color: "#555555",
                                      padding: "10px",
                                    }}
                                  >
                                    {getlcv(e, "destinationCountry")}
                                  </td>
                                  <td
                                    style={{
                                      color: "#555555",
                                      padding: "10px",
                                    }}
                                  >
                                    {getlcv(e, "pol")}
                                  </td>
                                  <td
                                    style={{
                                      color: "#555555",
                                      padding: "10px",
                                    }}
                                  >
                                    {getlcv(e, "pod")}
                                  </td>
                                  <td
                                    style={{
                                      color: "#555555",
                                      padding: "10px",
                                    }}
                                  >
                                    {getlcv(e, "rateType")}
                                  </td>
                                  <td
                                    style={{
                                      color: "#555555",
                                      padding: "10px",
                                    }}
                                  >
                                    {getlcv(e, "reductionPercentage")}
                                  </td>
                                  <td
                                    style={{
                                      color: "#555555",
                                      padding: "10px",
                                    }}
                                  >
                                    {getlcv(e, "reductionValue")}
                                  </td>
                                  <td
                                    style={{
                                      color: "#555555",
                                      padding: "10px",
                                    }}
                                  >
                                    {getlcv(e, "reductionValueCurrency")}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}

                    <div className="table-container">
                      <table style={{ border: "none", width: "100%" }}>
                        <tbody>
                          {req.err.map((e) => {
                            return (
                              <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                <td
                                  style={{ color: "#555555", padding: "10px" }}
                                >
                                  {e}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </Card>
                  <hr />
                </>
              )}
              {
                reviseCharges && <div
                className="field is-grouped"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {req.showapprove ? (
                  <div className="control">
                    <button
                      className="button"
                      style={{
                        backgroundColor:
                          process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                        color: "#fff",
                      }}
                      onClick={() => {
                        save("approve");
                      }}
                    >
                      Request Approve
                    </button>
                  </div>
                ) : (
                  <div className="control">
                    <button
                      className="button"
                      style={{
                        backgroundColor:
                          process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                        color: "#fff",
                      }}
                      onClick={() => {
                        save("save");
                      }}
                    >
                      Save
                    </button>
                  </div>
                )}
                <div className="control">
                  <button class="button is-danger" onClick={() => {
                    setValue('list',originallist)
                    if (isFCL) {
                      fclChargesStore.list = JSON.parse(JSON.stringify(originallist))
                      fclChargesStore.initialLength = originallist.length
                    }
                    setValue('pkb',originalpkblist)
                    setValue('rebate',originalrebatelist)
                    setReviseCharges(false)
                  }}>
                    Cancel
                  </button>
                </div>
              </div>
              }
            </>
          )}
        </>
      )}
    </>
  );
}
